// Third Party Imports
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import PropTypes from 'prop-types';
import {get} from 'lodash';

// Relative Imports
import appActions from '../../actions/actions';
import reviewPageActions from '../../actions/reviewPage';
import vatInformationActions from '../../actions/vatInformation';
import ReviewPage from './ReviewPage';
import {getFormElementsIds} from '../utils/addressUtil';
import {ADDRESS_TYPE_BILLING} from "../../utils/constants";
import { vatRegex } from '../../utils/validate';

function mapStateToProps(state) {
    return {
        publicUuid: get(state, 'app.publicUuid', ''),
        translations: state.app.translations,
        userType: get(state, 'app.userType', 'IPM'),
        serviceError: get(state, 'reviewPage.serviceError', ''),
        accountDetails: get(state, 'reviewPage.accountDetails', {}),
        vatDetails: get(state, 'reviewPage.vatDetails', {}),
        siteName: state.system.siteName,
        defaultLocale: state.system.locale,

        countryList: get(state, 'reviewPage.countryList', []),
        vatRegionCodes: get(state, 'reviewPage.vatRegionCodes', []),
        vatRegionCodeOptions: get(state, 'vatInformation.vatRegionCodeOptions', []),
        incompleteForm: get(state, 'reviewPage.incompleteForm', true),
        enableLoadOverlay: get(state, 'app.enableLoadOverlay', false),
        enableAccountModal: get(state, 'reviewPage.enableAccountModal', false),
        enableVatModal: get(state, 'reviewPage.enableVatModal', false),

        vatCountryCode: get(state, 'reviewPage.vatCountryCode', ''),
        vatRegionCode: get(state, 'reviewPage.vatRegionCode', ''),
        vatNumber: get(state, 'reviewPage.vatNumber', ''),
        addressLine1: get(state, 'reviewPage.addressLine1', ''),
        addressLine2: get(state, 'reviewPage.addressLine2', ''),
        city: get(state, 'reviewPage.city', ''),
        state: get(state, 'reviewPage.state', ''),
        postalCode: get(state, 'reviewPage.postalCode', ''),
        addressCountry: get(state, 'reviewPage.addressCountry', ''),

        vatCountryCodeError: get(state, 'reviewPage.vatCountryCodeError', ''),
        vatNumberError: get(state, 'reviewPage.vatNumberError', ''),
        addressLine1Error: get(state, 'reviewPage.addressLine1Error', ''),
        cityError: get(state, 'reviewPage.cityError', ''),
        stateError: get(state, 'reviewPage.stateError', ''),
        postalCodeError: get(state, 'reviewPage.postalCodeError', ''),
        addressCountryError: get(state, 'reviewPage.addressCountryError', ''),

        firstName: get(state, 'reviewPage.firstName', ''),
        lastName: get(state, 'reviewPage.lastName', ''),
        emailAddress: get(state, 'reviewPage.emailAddress', ''),
        phoneNumber: get(state, 'reviewPage.phoneNumber', ''),
        dialingCountryCode: get(state, 'reviewPage.dialingCountryCode', ''),
        companyName: get(state, 'reviewPage.companyName', ''),
        companyLocation: get(state, 'reviewPage.companyLocation', ''),
        companyCountryCode: get(state, 'reviewPage.companyCountryCode', ''),
        countryDialingNumber: get(state, 'reviewPage.countryDialingNumber'),

        firstNameError: get(state, 'reviewPage.firstNameError', ''),
        lastNameError: get(state, 'reviewPage.lastNameError', ''),
        phoneNumberError: get(state, 'reviewPage.phoneNumberError', ''),
        companyNameError: get(state, 'reviewPage.companyNameError', ''),
        companyCountryCodeError: get(state, 'reviewPage.companyCountryCodeError', ''),

        editModalServiceError: get(state, 'reviewPage.editModalServiceError', ''),
        updateServiceSuccess: get(state, 'reviewPage.updateServiceSuccess', ''),
        enableSaveButton: get(state, 'reviewPage.enableSaveButton', false),
        enableVatEditButton: get(state, 'reviewPage.enableVatEditButton', false),

        showVatChoice: get(state, 'reviewPage.showVatChoice', false),
        registrationDetails: get(state, 'reviewPage.registrationDetails', {}),
        showRegistrationNumber: get(state, 'reviewPage.showRegistrationNumber', false),

        registrationNumber: get(state, 'reviewPage.registrationNumber', ''),
        registrationNumberError: get(state, 'reviewPage.registrationNumberError', ''),

        vatChoice: get(state, 'reviewPage.vatChoice', 'No'),
        registrationNumberChoice: get(state, 'reviewPage.registrationNumberChoice', 'No'),
        addressChoice: get(state, 'reviewPage.addressChoice', 'Billing address'),

        billingCountry: get(state, 'reviewPage.billingCountry', ''),
        billingAddressLine1: get(state, 'reviewPage.billingAddressLine1', ''),
        billingAddressLine2: get(state, 'reviewPage.billingAddressLine2', ''),
        billingCity: get(state, 'reviewPage.billingCity', ''),
        billingState: get(state, 'reviewPage.billingState', ''),
        billingPostalCode: get(state, 'reviewPage.billingPostalCode', ''),

        billingCountryError: get(state, 'reviewPage.billingCountryError', ''),
        billingAddressLine1Error: get(state, 'reviewPage.billingAddressLine1Error', ''),
        billingCityError: get(state, 'reviewPage.billingCityError', ''),
        billingStateError: get(state, 'reviewPage.billingStateError', ''),
        billingPostalCodeError: get(state, 'reviewPage.billingPostalCodeError', ''),

        dyff: get(state, 'app.dyff', {})
    };
}

function mapDispatchToProps(dispatch) {
    return {
        appActions: bindActionCreators(appActions, dispatch),
        reviewPageActions: bindActionCreators(reviewPageActions, dispatch),
        vatInformationActions: bindActionCreators(vatInformationActions, dispatch),
        dispatch
    };
}

@connect(mapStateToProps, mapDispatchToProps)
export default class ReviewPageContainer extends React.Component {
    constructor(props) {
        super(props);
        this.handleContinueSubmit = this.handleContinueSubmit.bind(this);
        this.editOnClickHandler = this.editOnClickHandler.bind(this);
        this.handleAlertDismiss = this.handleAlertDismiss.bind(this);
        this.handleEditModalDismiss = this.handleEditModalDismiss.bind(this);
        this.handleEditModalSubmit = this.handleEditModalSubmit.bind(this);
        this.editFormOnchangeHandler = this.editFormOnchangeHandler.bind(this);
        this.triggerEdapPageViewAction = this.triggerEdapPageViewAction.bind(this);
        this.editFormOnBlurHandler = this.editFormOnBlurHandler.bind(this);
        this.handleModalAlertDismiss = this.handleModalAlertDismiss.bind(this);
        this.setDialingCountryCode = this.setDialingCountryCode.bind(this);
        this.setPhoneNumber = this.setPhoneNumber.bind(this);
        this.handleVatChoiceChange = this.handleVatChoiceChange.bind(this);
        this.handleRegistrationNumberChoiceChange = this.handleRegistrationNumberChoiceChange.bind(this);
        this.handleScrollToTop = this.handleScrollToTop.bind(this);
        this.handleChoiceChange = this.handleChoiceChange.bind(this);
    }

    componentWillMount() {
        this.props.appActions.enableLoadOverLay(true);
        this.props.reviewPageActions.getReviewMetadata();
        this.props.reviewPageActions.toggleVatEditButton();
    }

    componentWillReceiveProps(nextProps) {
        if (this.hasVatCountryChanged(nextProps)) {
            this.props.vatInformationActions.getVatRegionCodes(nextProps.vatDetails.countryCode, nextProps.vatRegionCodes);
        }

        if (this.isUpdateServiceSuccess(nextProps)) {
            this.props.appActions.enableLoadOverLay(true);
            this.props.reviewPageActions.getReviewMetadata();
        }
    }

    hasVatCountryChanged = (nextProps) => this.props.vatDetails.countryCode !== nextProps.vatDetails.countryCode;

    isUpdateServiceSuccess = (nextProps) => !this.props.updateServiceSuccess && nextProps.updateServiceSuccess;

    handleContinueSubmit(event) {
        event.preventDefault();
        this.props.appActions.triggerEdapEvent('generic.click', {
            eventcategory: 'Continue'
        }, {});

        if (this.props.dyff?.SHARED_HANDLE_SSO_LANGUAGE_CURRENCY_MISMATCH) {
            this.props.appActions.changeAppState('INTRODUCTION');
        } else {
            this.props.appActions.changeAppState('PROPERTY_COUNT');
        }
    }

    triggerEdapPageViewAction(action) {
        this.props.appActions.triggerEdapPageView(this.props.publicUuid, action);
    }

    editOnClickHandler(event) {
        event.preventDefault();
        const editBtnId = event.target.id || event.target.parentElement.id;
        let editFormType;

        if (editBtnId === 'accountInfoEdit') {
            editFormType = 'Account info edit';
            this.triggerEdapEditAction(editFormType);
            this.triggerEdapPageViewAction('Account Info Edit Form');
        } else if (editBtnId === 'vatInfoEdit') {
            editFormType = 'VAT info edit';
            this.triggerEdapEditAction(editFormType);
            this.triggerEdapPageViewAction('VAT Info Edit Form');
        }

        const {defaultLocale} = this.props;
        this.props.reviewPageActions.toggleEditModal(editFormType, true, defaultLocale);
        this.props.reviewPageActions.toggleSaveButton();
    }

    triggerEdapEditAction(action) {
        this.props.appActions.triggerEdapEvent('generic.click', {
            eventcategory: action
        }, {});
    }

    handleAlertDismiss() {
        this.props.reviewPageActions.alertError('');
    }

    handleModalAlertDismiss() {
        this.props.reviewPageActions.alertErrorForModal('');
    }

    handleEditModalDismiss = (event) => {
        event.preventDefault();
        const editFormType = this.props.enableAccountModal ? 'Account info edit' : 'VAT info edit';
        this.triggerEdapEditAction(`${editFormType}: modal close`);
        const {defaultLocale} = this.props;
        this.props.reviewPageActions.toggleEditModal(editFormType, false, defaultLocale);
    };

    editFormOnchangeHandler(event) {
        this.setFieldsError(event.target.id);
        this.props.reviewPageActions.setField(event.target.id, event.target.value);
        // handle VAT validation
        if (event.target.id === 'vatNumber') {
            this.validateVatNumber(event);
        }
        if (event.target.id === 'vatCountry') {
            this.props.vatInformationActions.getVatRegionCodes(event.target.value, this.props.vatRegionCodes);
        }
        this.props.reviewPageActions.toggleSaveButton();
    }

    validateVatNumber(event) {
        event.preventDefault();
        this.props.reviewPageActions.setFieldError(event.target.id, '');
        if (!event.target.value) {
            this.props.reviewPageActions.setFieldError(event.target.id, 'ipmob.input.field.required');
        } else if (!vatRegex.test(event.target.value)) {
                this.props.reviewPageActions.setFieldError(event.target.id, 'ipmob.input.field.vat_format');
        }
    }

    setFieldsError(errorField) {
        const {enableAccountModal, enableVatModal, showRegistrationNumber} = this.props;

        if (enableVatModal) {
            if (showRegistrationNumber) {
                this.setRegistrationInfoFormFieldsError(errorField);
            } else {
                this.setVatFormFieldsError(errorField);
            }
        } else if (enableAccountModal) {
            this.setAccountFormFieldsError(errorField);
        }
    }

    setRegistrationInfoFormFieldsError(errorField) {
        this.props.reviewPageActions.setFieldError(errorField, '');
    }

    handleChoiceChange(event) {
        this.props.reviewPageActions.setAddressChoice(event.target.value);
        this.props.reviewPageActions.toggleSaveButton();

        this.props.appActions.triggerEdapEvent('generic.event', {
            eventcategory: event.target.value === 'Mailing address' ? 'Same as mailing address selected' : 'Different billing address selected',
            eventaction: 'Address preference selected',
            highfrequency: 'true'
        }, {});
    }

    setVatFormFieldsError(errorField) {
        const addressFieldIds = getFormElementsIds();
        const fields = [
            'vatCountry',
            'vatRegionCode'
        ].concat(addressFieldIds);

        for (const fieldVal of fields) {
            if (fieldVal === errorField) {
                this.props.reviewPageActions.setFieldError(fieldVal, '');
                break;
            }

            if ((fieldVal === 'vatCountry' && !this.props.vatCountryCode)
                || (fieldVal === 'vatRegionCode' && !this.props.vatRegionCode)
                || (fieldVal === 'country' && !this.props.addressCountry)
                || (fieldVal === 'address1' && !this.props.addressLine1)
                || (fieldVal === 'city' && !this.props.city)
                || ((fieldVal === 'stateProvince') && !this.props.state)
                || (fieldVal === 'postalCode' && !this.props.postalCode)
            ) {
                this.props.reviewPageActions.setFieldError(fieldVal, 'ipmob.input.field.required');
            }
        }
    }

    // eslint-disable-next-line complexity
    setAccountFormFieldsError(errorField) {
        const addressFieldIds = getFormElementsIds();
        const billingAddressFieldIds = getFormElementsIds(ADDRESS_TYPE_BILLING);
        const fields = [
            'firstName',
            'lastName',
            'phoneNumber',
            'companyName',
            'companyCountryCode'
        ].concat(addressFieldIds).concat(billingAddressFieldIds);

        for (const fieldVal of fields) {
            if (fieldVal === errorField) {
                this.props.reviewPageActions.setFieldError(fieldVal, '');
                break;
            }

            if ((fieldVal === 'firstName' && !this.props.firstName)
                || (fieldVal === 'lastName' && !this.props.lastName)
                || (fieldVal === 'phoneNumber' && !this.props.phoneNumber)
                || (fieldVal === 'companyName' && !this.props.companyName)
                || (fieldVal === 'companyCountryCode' && !this.props.companyCountryCode)
                || (fieldVal === 'country' && !this.props.addressCountry)
                || (fieldVal === 'address1' && !this.props.addressLine1)
                || (fieldVal === 'city' && !this.props.city)
                || ((fieldVal === 'stateProvince') && !this.props.state)
                || (fieldVal === 'postalCode' && !this.props.postalCode)
                || (fieldVal === 'billing_country' && !this.props.billingCountry)
                || (fieldVal === 'billing_address1' && !this.props.billingAddressLine1)
                || (fieldVal === 'billing_city' && !this.props.billingCity)
                || ((fieldVal === 'billing_stateProvince') && !this.props.billingState)
                || (fieldVal === 'billing_postalCode' && !this.props.billingPostalCode)
            ) {
                this.props.reviewPageActions.setFieldError(fieldVal, 'ipmob.input.field.required');
            }
        }
    }

    editFormOnBlurHandler(event) {
        let edapEvents = {
            eventcategory: event.target.id,
            eventaction: 'Value Entered'
        };
        event.preventDefault();
        if (event.target.id === 'vatCountry' || event.target.id === 'country' || event.target.id === 'companyCountryCode'
            || event.target.id === 'vatRegionCode' || event.target.id === 'billing_country') {
            edapEvents.eventaction = 'value selected';
            edapEvents = {...edapEvents, highfrequency: 'true'};
        }
        this.props.appActions.triggerEdapEvent('generic.event', edapEvents, {});
        if (!event.target.value.trim()) {
            this.setFieldsError(event.target.id);
            this.props.reviewPageActions.setFieldError(event.target.id, 'ipmob.input.field.required');
        } else if (event.target.id === 'vatNumber') {
            this.validateVatNumber(event);
        }
    }

    handleEditModalSubmit = (event) => {
        event.preventDefault();
        const editFormId = event.target.id || event.target.parentElement.id;
        this.props.appActions.enableLoadOverLay(true);
        if (editFormId === 'vatSubmit') {
            let edapAction;
            let vatDetails = {};

            if (this.props.showRegistrationNumber && this.props.vatChoice === 'No') {
                edapAction = 'Submit registration number';
                vatDetails = {
                    countryCode: this.props.vatCountryCode,
                    registrationNumber: this.props.registrationNumber,
                };
            } else {
                edapAction = 'Submit VAT info';
                vatDetails = {
                    addresses: {
                        countryCode: this.props.vatCountryCode,
                        vatNumber: this.props.vatNumber,
                        regionCode: this.props.vatRegionCode,
                        country: this.props.addressCountry,
                        address1: this.props.addressLine1,
                        address2: this.props.addressLine2,
                        city: this.props.city,
                        stateProvince: this.props.state,
                        postalCode: this.props.postalCode
                    }
                };
            }
            this.triggerEdapEditAction(edapAction);
            this.props.vatInformationActions.updateVatDetails(vatDetails);
        } else if (editFormId === 'accountSubmit') {
            const accountDetails = {
                firstName: this.props.firstName,
                lastName: this.props.lastName,
                companyName: this.props.companyName,
                companyLocation: this.props.companyCountryCode,
                contact: {
                    phone: {
                        countryCode: this.props.countryDialingNumber || this.inputTel.state.phoneCode,
                        number: this.props.phoneNumber

                    },
                    addresses: [
                        {
                            address1: this.props.addressLine1,
                            address2: this.props.addressLine2,
                            city: this.props.city,
                            stateProvince: this.props.state,
                            country: this.props.addressCountry,
                            postalCode: this.props.postalCode,
                            addressType: 'CONTACT'
                        },
                        {
                            address1: this.props.billingAddressLine1,
                            address2: this.props.billingAddressLine2,
                            city: this.props.billingCity,
                            stateProvince: this.props.billingState,
                            country: this.props.billingCountry,
                            postalCode: this.props.billingPostalCode,
                            addressType: 'BILLING'
                        }
                    ]
                }
            };

            this.triggerEdapEditAction('Submit account info');
            this.props.reviewPageActions.updateAccountDetails(accountDetails);
            this.props.reviewPageActions.toggleVatEditButton();
        }
    }

    setDialingCountryCode(event, countryData) {
        this.props.reviewPageActions.setField('dialingCountryCode', countryData.cc);
        this.props.reviewPageActions.setField('countryDialingNumber', countryData.phoneCode);
    }

    setPhoneNumber(event, phoneObject) {
        this.props.reviewPageActions.setField('phoneNumber', phoneObject.raw);
        if (phoneObject.raw) {
            this.setFieldsError('phoneNumber');
        }

        this.props.reviewPageActions.toggleSaveButton();
    }

    handleVatChoiceChange(event) {
        this.props.appActions.triggerEdapEvent('generic.event', {
            eventcategory: (event.target.id === 'vatChoiceYes') ? 'VAT choice Yes selected' : 'VAT choice No selected',
            eventaction: 'VAT choice selected',
            highfrequency: 'true'
        });
        this.props.reviewPageActions.setField(event.target.id, event.target.value);
    }

    handleRegistrationNumberChoiceChange(event) {
        this.props.appActions.triggerEdapEvent('generic.event', {
            eventcategory: (event.target.id === 'registrationNumberYes') ? 'Has Registration Number' : 'Has no Registration Number',
            eventaction: 'Registration Number choice selected',
            highfrequency: 'true'
        });
        this.props.reviewPageActions.setField(event.target.id, event.target.value);
        this.props.reviewPageActions.toggleSaveButton();
    }

    handleScrollToTop() {
        const elements = document.getElementsByClassName('Modal');
        if (elements.length > 0 && elements[0]) {
            let modalElem = elements[0];

            // Check element has no scroll property
            if (modalElem.scrollHeight <= modalElem.clientHeight) {
                modalElem = document.getElementsByClassName('Modal__body')[0];
            }

            modalElem.scrollTop = 0;
        }
    }

    getInputTel = (ref) => {
        this.inputTel = ref;
    }

    render() {
        return (
            <ReviewPage
                translations={this.props.translations}
                triggerEdapPageViewAction={this.triggerEdapPageViewAction}
                publicUuid={this.props.publicUuid}
                enableLoadOverlay={this.props.enableLoadOverlay}

                handleEditFormSubmit={this.handleEditFormSubmit}
                handleContinueSubmit={this.handleContinueSubmit}
                accountDetails={this.props.accountDetails}
                vatDetails={this.props.vatDetails}
                userType={this.props.userType}
                serviceError={this.props.serviceError}
                handleAlertDismiss={this.handleAlertDismiss}

                enableAccountModal={this.props.enableAccountModal}
                enableVatModal={this.props.enableVatModal}
                editOnClickHandler={this.editOnClickHandler}

                incompleteForm={this.props.incompleteForm}
                handleEditModalDismiss={this.handleEditModalDismiss}
                handleEditModalSubmit={this.handleEditModalSubmit}

                countryList={this.props.countryList}
                vatRegionCodeOptions={this.props.vatRegionCodeOptions}

                editFormOnchangeHandler={this.editFormOnchangeHandler}

                vatCountryCode={this.props.vatCountryCode}
                vatCountryCodeError={this.props.vatCountryCodeError}

                vatRegionCode={this.props.vatRegionCode}

                vatNumber={this.props.vatNumber}
                vatNumberError={this.props.vatNumberError}

                editFormOnBlurHandler={this.editFormOnBlurHandler}

                handleAddressLine1Change={this.editFormOnchangeHandler}
                addressLine1={this.props.addressLine1}
                addressLine1Error={this.props.addressLine1Error}
                onAddress1Blur={this.editFormOnBlurHandler}

                handleAddressLine2Change={this.editFormOnchangeHandler}
                addressLine2={this.props.addressLine2}
                onAddress2Blur={this.editFormOnBlurHandler}

                handleCityChange={this.editFormOnchangeHandler}
                city={this.props.city}
                cityError={this.props.cityError}
                onCityBlur={this.editFormOnBlurHandler}

                handleStateChange={this.editFormOnchangeHandler}
                handleSelectStateChange={this.editFormOnchangeHandler}
                state={this.props.state}
                stateError={this.props.stateError}
                onStateBlur={this.editFormOnBlurHandler}
                onSelectedStateBlur={this.editFormOnBlurHandler}

                handlePostalCodeChange={this.editFormOnchangeHandler}
                postalCode={this.props.postalCode}
                postalCodeError={this.props.postalCodeError}
                onPostalCodeBlur={this.editFormOnBlurHandler}

                handleCountryChange={this.editFormOnchangeHandler}
                addressCountry={this.props.addressCountry}
                addressCountryError={this.props.addressCountryError}
                onCountryBlur={this.editFormOnBlurHandler}

                firstName={this.props.firstName}
                lastName={this.props.lastName}
                emailAddress={this.props.emailAddress}
                phoneNumber={this.props.phoneNumber}
                dialingCountryCode={this.props.dialingCountryCode}
                companyName={this.props.companyName}
                companyLocation={this.props.companyLocation}
                companyCountryCode={this.props.companyCountryCode}

                firstNameError={this.props.firstNameError}
                lastNameError={this.props.lastNameError}
                phoneNumberError={this.props.phoneNumberError}
                companyNameError={this.props.companyNameError}
                companyCountryCodeError={this.props.companyCountryCodeError}

                handlePhoneNumberChange = {this.setPhoneNumber}
                handleCountryCodeChange = {this.setDialingCountryCode}

                editModalServiceError={this.props.editModalServiceError}
                handleModalAlertDismiss={this.handleModalAlertDismiss}
                enableSaveButton={this.props.enableSaveButton}

                enableVatEditButton={this.props.enableVatEditButton}

                showVatChoice={this.props.showVatChoice}
                registrationDetails={this.props.registrationDetails}
                showRegistrationNumber={this.props.showRegistrationNumber}

                registrationNumber={this.props.registrationNumber}
                registrationNumberError={this.props.registrationNumberError}

                vatChoice={this.props.vatChoice}
                registrationNumberChoice={this.props.registrationNumberChoice}
                handleVatChoiceChange={this.editFormOnchangeHandler}

                handleRegistrationNumberChoiceChange={this.handleRegistrationNumberChoiceChange}
                handleRegistrationNumberChange={this.editFormOnchangeHandler}
                handleRegistrationNumberOnBlur={this.editFormOnBlurHandler}
                scrollModalToTop={this.handleScrollToTop}
                siteName={this.props.siteName}

                getInputTel={this.getInputTel}
                handleChoiceChange={this.handleChoiceChange}
                choice={this.props.addressChoice}

                handleBillingAddressLine1Change={this.editFormOnchangeHandler}
                billingAddressLine1={this.props.billingAddressLine1}
                billingAddressLine1Error={this.props.billingAddressLine1Error}
                onBillingAddress1Blur={this.editFormOnBlurHandler}

                handleBillingAddressLine2Change={this.editFormOnchangeHandler}
                billingAddressLine2={this.props.billingAddressLine2}
                onBillingAddress2Blur={this.editFormOnBlurHandler}

                handleBillingCityChange={this.editFormOnchangeHandler}
                billingCity={this.props.billingCity}
                billingCityError={this.props.billingCityError}
                onBillingCityBlur={this.editFormOnBlurHandler}

                handleBillingStateChange={this.editFormOnchangeHandler}
                handleBillingSelectStateChange={this.editFormOnchangeHandler}
                billingState={this.props.billingState}
                billingStateError={this.props.billingStateError}
                onBillingStateBlur={this.editFormOnBlurHandler}
                onBillingSelectedStateBlur={this.editFormOnBlurHandler}

                handleBillingPostalCodeChange={this.editFormOnchangeHandler}
                billingPostalCode={this.props.billingPostalCode}
                billingPostalCodeError={this.props.billingPostalCodeError}
                onBillingPostalCodeBlur={this.editFormOnBlurHandler}

                handleBillingCountryChange={this.editFormOnchangeHandler}
                billingCountry={this.props.billingCountry}
                billingCountryError={this.props.billingCountryError}
                onBillingCountryBlur={this.editFormOnBlurHandler}

            />
        );
    }
}

ReviewPageContainer.propTypes = {
    publicUuid: PropTypes.string,
    translations: PropTypes.any, // eslint-disable-line react/forbid-prop-types
    siteName: PropTypes.string,
    serviceError: PropTypes.string,
    vatDetails: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    accountDetails: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    incompleteForm: PropTypes.bool,
    enableAccountModal: PropTypes.bool,
    enableVatModal: PropTypes.bool,
    enableSaveButton: PropTypes.bool,
    enableVatEditButton: PropTypes.bool,
    addressChoice: PropTypes.string
};

ReviewPageContainer.defaultProps = {
    addressChoice: 'Billing address'
};
